// @ts-ignore
import merge from 'deepmerge';
import { IAuthState, IAuthAction, AuthTypes, UserTypes } from "./types";
import { AUTH_STORAGE_KEY } from "../../../share/utils/apiAuthToken";
import storageManager from "../../../share/utils/localStorage";
import _ from 'lodash';
import { TermsOfUseUserStatus } from 'src/share/types/termsOfUse';
import { sessionTime } from 'src/modules/Auth/helpers/sessionTime';

const unauthState: IAuthState = {
    userType: UserTypes.UNAUTH,
    idToken: null,
    agencyCode: '',
    lastLogin: 0,
    accessToken: null,
    refreshToken: null,
    username: '',
    errorMessage: '',
    loading: false,
    agencies: [],
    notifications: [],
    termsOfUseStatus: TermsOfUseUserStatus.NoRecords
}

export const initialAuthState = (): IAuthState => {
    const storagedData = storageManager.get(AUTH_STORAGE_KEY) as IAuthState;
    if (storagedData) {
        const { isExpired } = sessionTime(storagedData)
        if (isExpired) {
            storageManager.clear()
            return unauthState
        }
        return storagedData
    } else {
        return unauthState
    }
}
export const authReducer = (state = _.cloneDeep(initialAuthState()), action: IAuthAction): IAuthState => {
    switch (action.type) {
        case AuthTypes.LogIn:
            return action.payload;
        case AuthTypes.LogInFailed:
            return {
                userType: action.payload.userType,
                idToken: action.payload.idToken,
                accessToken: action.payload.accessToken,
                refreshToken: action.payload.refreshToken,
                username: action.payload.username,
                errorMessage: action.payload.errorMessage,
                loading: action.payload.loading,
                agencies: action.payload.agencies,
                agencyCode: action.payload.agencyCode,
                notifications: action.payload.notifications,
                lastLogin: action.payload.lastLogin,
                termsOfUseStatus: action.payload.termsOfUseStatus
            }
        case AuthTypes.LogInLoading:
            return {
                userType: action.payload.userType,
                idToken: action.payload.idToken,
                accessToken: action.payload.accessToken,
                refreshToken: action.payload.refreshToken,
                username: action.payload.username,
                errorMessage: action.payload.errorMessage,
                loading: action.payload.loading,
                agencies: action.payload.agencies,
                agencyCode: action.payload.agencyCode,
                notifications: action.payload.notifications,
                lastLogin: action.payload.lastLogin,
                termsOfUseStatus: action.payload.termsOfUseStatus
            }
        case AuthTypes.RefreshLogin:
            return {
                ...state,
                idToken: action.payload.idToken,
                accessToken: action.payload.accessToken,
                refreshToken: action.payload.refreshToken,
                errorMessage: action.payload.errorMessage,
                loading: action.payload.loading,
            }
        case AuthTypes.GetAgencies:
            return {
                ...state,
                agencies: action.payload.agencies
            }
        case AuthTypes.GetNotifications:
            return {
                ...state,
                notifications: action.payload.notifications
            }
        case AuthTypes.DeleteNotifications:
            const { type } = action.payload;

            return type ? {
                ...state,
                notifications: {
                    ...state.notifications,
                    [type]: {}
                },
            } : state;
        case AuthTypes.LogOut:
            return {
                userType: UserTypes.UNAUTH,
                idToken: {
                    jwtToken: "string",
                    payload: {}
                },
                accessToken: null,
                refreshToken: null,
                username: '',
                errorMessage: '',
                loading: false,
                agencyCode: '',
                notifications: {},
                lastLogin: null,
                agencies: [],
                termsOfUseStatus: TermsOfUseUserStatus.NoRecords
            };
        case AuthTypes.TermsOfUseStatus:
            return {
                ...state,
                termsOfUseStatus: action.payload.termsOfUseStatus
            }
        default:
            return state;
    }
}